"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _Page = _interopRequireDefault(require("./Page"));

var _constants = require("composer-lib/lib/constants");

function parsePages(data) {
  return new _immutable.List(data.map(function (item) {
    var name = item.name,
        absoluteUrl = item.absoluteUrl;
    return new _Page.default({
      help: absoluteUrl,
      text: name,
      value: absoluteUrl
    });
  }));
}

var DEFAULTS = {
  data: new _immutable.List(),
  status: _constants.RequestStatus.UNINITIALIZED
};

var Pages = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Pages, _Record);

  function Pages() {
    (0, _classCallCheck2.default)(this, Pages);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Pages).apply(this, arguments));
  }

  (0, _createClass2.default)(Pages, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new Pages({
        data: parsePages(data.objects),
        status: _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return Pages;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Pages;
module.exports = exports.default;